import React, { useState } from 'react';

const CommonFileInput = ({
    name,
    label,
    value,
    onChange,
    existingFile,
    baseUrl='',
    icon,
    required = false,
    disabled = false,
    errors,
    className = 'mb-3',
    inputClassName = '',
    displayError = true,
    accept = 'image/*',
    progress = 0,
    isUploading = false,
    uploadSuccess = false,
    ...props
}) => {
    const handleClose = () => {
        if (onChange) {
            onChange({ target: { name, value: null } });
        }
    };

    return (
        <div className={`${className}`}>
            {label && (
                <label className="form-label">
                    {label}
                    {required && <span className="text-danger ms-1">*</span>}
                </label>
            )}
            
            {existingFile ? (
                <div className="d-flex align-items-center gap-2">
                    {icon && (
                        <a 
                            href={`${baseUrl}/file/${existingFile}`} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="text-decoration-none"
                        >
                            <i className={icon}></i>
                        </a>
                    )}
                    <button
                        type="button"
                        className="btn btn-sm btn-danger"
                        onClick={handleClose}
                        disabled={disabled}
                    >
                        <i className="fa fa-times"></i>
                    </button>
                </div>
            ) : (
                <>
                    <div className="position-relative">
                        <input
                            type="file"
                            name={name}
                            onChange={onChange}
                            className={`form-control ${inputClassName} ${errors?.[name] ? 'is-invalid' : ''}`}
                            disabled={disabled || isUploading}
                            accept={accept}
                            {...props}
                        />
                        {isUploading && (
                            <div className="position-absolute top-50 end-0 translate-middle-y me-2">
                                <div className="spinner-border spinner-border-sm text-primary" role="status">
                                    <span className="visually-hidden">Uploading...</span>
                                </div>
                            </div>
                        )}
                        {uploadSuccess && !isUploading && (
                            <div className="position-absolute top-50 end-0 translate-middle-y me-2">
                                <i className="fas fa-check-circle text-success"></i>
                            </div>
                        )}
                    </div>
                    {isUploading && (
                        <div className="progress mt-2">
                            <div 
                                className="progress-bar progress-bar-striped progress-bar-animated" 
                                role="progressbar" 
                                style={{ width: `${progress}%` }} 
                                aria-valuenow={progress} 
                                aria-valuemin="0" 
                                aria-valuemax="100"
                            >
                                {progress}%
                            </div>
                        </div>
                    )}
                    {uploadSuccess && !isUploading && (
                        <div className="alert alert-success alert-sm mt-2 mb-0">
                            <i className="fas fa-check-circle me-1"></i>
                            File uploaded successfully!
                        </div>
                    )}
                </>

            )}
            
            {displayError && errors?.[name] && (
                <div className="invalid-feedback">
                    {Array.isArray(errors[name]) ? errors[name][0] : errors[name]}
                </div>
            )}
        </div>
    );
};

export default CommonFileInput; 